import { render } from "./dProcess.vue?vue&type=template&id=988b1228&ts=true"
import script from "./dProcess.vue?vue&type=script&lang=ts"
export * from "./dProcess.vue?vue&type=script&lang=ts"

import "./dProcess.vue?vue&type=style&index=0&id=988b1228&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__